import { Title } from "../../../../../components/Title";
import claimPayIcon from '../../../../../assets/claim-pay-icon.svg';

export const PropOwnerTitle = () => <Title title='Property Owner'>
  <img alt='claimpay' src={claimPayIcon} />
</Title>